<template>
  <v-layout v-if="!month">
    <vc-date-picker
      v-model="date"
      class="calendar-date-picker"
      mode="date"
      :is-range="range"
      :attributes="attributes"
      :locale="locale"
      color="gray"
      :is-required="true"
      :first-day-of-week="2"
      :disabled-dates="range ? undefined : { weekdays: disabledWeekdays}"
      :min-date="minDate"
      :model-config="dateModelConfig"
    >
      <template v-slot="{ togglePopover, hidePopover }">
        <v-text-field
          ref="focus"
          :value="range ? `${date.start} / ${date.end}` : date"
          :label="$t(label ? label : 'common.selectedDate')"
          readonly
          :prepend-icon="icon"
          :clearable="clearable"
          :placeholder="dateFormat"
          persistent-placeholder
          @click="togglePopover()"
          @focusout="blurCheck($event) ? hidePopover() : ''"
        />
      </template>
    </vc-date-picker>
  </v-layout>
  <v-layout v-else>
    <v-menu
      v-model="menu"
      lazy
      transition="scale-transition"
      offset-y
      full-width
      :nudge-right="40"
      max-width="290px"
      min-width="290px"
    >
      <v-text-field
        slot="activator"
        v-model="date"
        :label="$t(label ? label : 'common.selectedDate')"
        readonly
        :prepend-icon="icon"
        :clearable="clearable"
        :placeholder="dateFormat"
        persistent-placeholder
      />
      <v-date-picker
        v-model="date"
        :locale="locale"
        type="month"
        color="primary"
        no-title
        scrollable
        autosave
      />
    </v-menu>
  </v-layout>
</template>

<script>
import moment from 'moment';
import { mapGetters } from 'vuex';
import TimeService from '@/services/TimeService';

export default {
  name: 'DatePicker',
  props: {
    selectedDate: {
      type: String,
      default: undefined,
    },
    selectedDateRange: {
      type: Object,
      default: () => ({
        start: '',
        end: '',
      }),
    },
    month: Boolean,
    range: Boolean,
    disabledWeekdays: {
      type: Array,
      default: () => [1, 7],
    },
    label: {
      type: String,
      default: undefined,
    },
    icon: {
      type: String,
      default: '',
    },
    nullable: {
      type: Boolean,
      default: false,
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    minDate: {
      type: String,
      default: undefined,
    },
  },
  data() {
    return {
      menu: false,
      modal: false,
      date: null,
      attributes: [
        {
          key: 'today',
          highlight: {
            color: 'gray',
            fillMode: 'outline',
          },
          dates: new Date(),
        },
      ],
      dateModelConfig: {
        type: 'string',
        mask: 'YYYY-MM-DD',
      },
    };
  },
  computed: {
    ...mapGetters('userInfoStore', ['locale']),
    dateFormat() {
      return this.month ? TimeService.monthFormat : TimeService.dateFormat;
    },
  },
  watch: {
    selectedDate(newValue) {
      this.date = this.range ? { start: newValue.start, end: newValue.end } : newValue;
    },
    date(newValue) {
      this.$emit('onDateUpdate', newValue);
    },
  },
  beforeMount() {
    this.date = this.range ? { start: this.selectedDate, end: this.selectedDate } : this.selectedDate;
    if ((!this.date || !this.date.start) && !this.nullable) {
      const today = moment().format(this.dateFormat);
      this.date = this.range ? { start: today, end: today } : today;
    }
  },
  methods: {
    getNextMonday() {
      const thisMonday = moment().startOf('isoWeek');
      return thisMonday.add(1, 'week').format(TimeService.dateFormat);
    },
    blurCheck(e) {
      const calendarClasses = ['vc-container', 'vc-nav-item', 'vc-day-content', 'vc-nav-title', 'vc-nav-arrow'];
      if (e.relatedTarget) {
        if (calendarClasses.some(c => e.relatedTarget.classList.contains(c))) {
          this.$refs.focus.focus();
          return false;
        }
      }
      return true;
    },
  },
};
</script>
